import React, { useState } from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import SearchContainer from 'containers/ExpertHomePage/SearchContainer';
import { Listings } from 'containers/AppContainer/typings';
import { makeSelectListings } from 'containers/AppContainer/selectors';
import { SearchQuery } from 'containers/ExpertHomePage/typings';
import {
  requestFindMissions,
  resetFoundMissionsStore,
} from 'containers/ExpertHomePage/actions';
import { makeSelectedMissions } from 'containers/ExpertHomePage/selectors';
import ResultSearchTable from 'containers/ExpertHomePage/ResultSearchTable';
export interface ExpertHomePageProps {
  requestFindMissions: Function;
  resetFoundMissionsStore: Function;
  foundMissions: any;
  listings: Listings;
}

const ExpertHomePage: React.FC<ExpertHomePageProps> = (props): JSX.Element => {
  const [firstSearch, setFirstSearch] = useState(false);
  const [searchQuery, setSearchQuery] = React.useState<SearchQuery>({
    cin: null,
    claimNumber: null,
    reference: null,
  });

  /* istanbul ignore next */
  const submitSearch = () => {
    setFirstSearch(true);
    props.resetFoundMissionsStore();
    props.requestFindMissions({ ...searchQuery, isLawyer: true });
  };

  /* istanbul ignore next */
  const handlerRefresh = () => {
    setFirstSearch(false);
    props.resetFoundMissionsStore();
  };

  return (
    <div>
      <SearchContainer
        searchQuery={searchQuery}
        onChangeSearchQuery={setSearchQuery}
        submitSearch={submitSearch}
        refreshSearch={handlerRefresh}
      />
      {firstSearch && (
        <ResultSearchTable
          missions={get(props.foundMissions, 'missions')}
          missionStatusIds={get(props.listings, 'missionStatus', [])}
        />
      )}
    </div>
  );
};

const mapDispatchToProps = {
  requestFindMissions,
  resetFoundMissionsStore,
};

const mapStateToProps = createStructuredSelector({
  foundMissions: makeSelectedMissions(),
  listings: makeSelectListings(),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExpertHomePage);
